import React, { useEffect, useState } from "react";
import { FaUserCheck } from "react-icons/fa6";
import EditPopUp from "./EditPopUp";
import Pagination from "Components/Pagination/Pagination";
import TableLoader from "Components/Common/Loader/TableLoader"; // ✅ import loader
import axios from "axios";

const BlockUsers = ({ currentTabPermissions }) => {
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Pagination states (from backend)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlockedUsers = async (page = 1) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/users/blocked?page=${page}&limit=5`
      );

      if (res.data.success) {
        setBlockedUsers(res.data.data);
        setTotalPages(res.data.totalPages);
        setCurrentPage(res.data.page);
      }
    } catch (err) {
      console.error("Error fetching blocked users:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlockedUsers(currentPage);
  }, [currentPage]);

  const handelOpenModal = (item) => {
    setEditPopupOpen(true);
    setSelectedItem(item);
  };

  const handleEditClose = () => {
    fetchBlockedUsers(currentPage);
    setEditPopupOpen(false);
  };

  return (
    <React.Fragment>
      <EditPopUp
        selectedItem={selectedItem}
        editPopupOpen={editPopupOpen}
        handleEditClose={handleEditClose}
      />

      <div className="mx-auto mt-5 w-auto rounded-t-2xl">
        <div className="overflow-x-auto rounded-t-2xl">
          {loading ? (
            <TableLoader />
          ) : (
            <table className="w-full rounded-t-2xl text-left text-sm">
              <thead className="text-md bg-[#e0ced7] uppercase tracking-wide text-navy-900">
                <tr>
                  <th className="px-6 py-3">Sl No.</th>
                  <th className="px-6 py-3">Name</th>
                  <th className="px-6 py-3">Phone</th>
                  <th className="px-6 py-3">Language</th>
                  {currentTabPermissions?.edit && (
                    <th className="px-6 py-3">Action</th>
                  )}
                </tr>
              </thead>

              <tbody>
                {blockedUsers.length > 0 ? (
                  blockedUsers.map((row, index) => (
                    <tr
                      className="text-md bg-white tracking-wide text-gray-700"
                      key={row._id}
                    >
                      <td className="whitespace-nowrap border border-[#ddd9db] px-6 py-4">
                        {(currentPage - 1) * 5 + index + 1}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.fullName}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.phone}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {row.preferred_Language || "-"}
                      </td>
                      <td className="border border-[#ddd9db] px-6 py-4">
                        {currentTabPermissions?.edit && (
                          <div
                            onClick={() => handelOpenModal(row)}
                            className="flex cursor-pointer items-center gap-2"
                          >
                            <FaUserCheck size={22} color="#38e000" />
                            <span className="text-[#38e000]">Unblock User</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="py-4 text-center">
                      No blocked users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* PAGINATION */}
      {totalPages > 1 && !loading && (
        <Pagination
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </React.Fragment>
  );
};

export default BlockUsers;
